import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { FilterChip, DatePickerComponent } from 'components';
import _ from 'lodash';
import moment from 'moment';
import _debug from 'debug';
import * as util from 'lib/utility';
import * as actions from 'state/modules/filter';
import { VirtualizedSelect } from 'containers';
import { Button } from 'react-toolbox/lib/button';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './InspectionFilter.css';

const debug = _debug('app:InspectionFilter');

export class InspectionFilter extends Component {
  static defaultProps = {
    options: [],
  }
  static propTypes = {
    updateInspectionFilterExpanded: PropTypes.func,
    inspectionFilterExpanded: PropTypes.bool,
    activeIndex: PropTypes.number,
    inspectionFilterData: PropTypes.arrayOf(PropTypes.shape({})),
    filterValues: PropTypes.shape({
      cica_writingagent: PropTypes.arrayOf(PropTypes.string),
      product: PropTypes.arrayOf(PropTypes.string),
      division: PropTypes.arrayOf(PropTypes.string),
      cica_appdate: PropTypes.arrayOf(PropTypes.string)
    }),
    list: PropTypes.arrayOf(React.PropTypes.shape({})),
    updateFilter: PropTypes.func,
    applyFilter: PropTypes.func,
    clearFilter: PropTypes.func,
    activeFilter: PropTypes.string,
    activeFilterReplica: PropTypes.arrayOf(PropTypes.shape({})),
    replicateActiveFilter: PropTypes.func,
    setActiveFilter: PropTypes.func,
    updateNameSearchParameter: PropTypes.func,
    updateWritingAgentParameter: PropTypes.func,
    resetActiveFilter: PropTypes.func,
    rawInspectionsData: PropTypes.arrayOf(PropTypes.shape({})),
    strings: React.PropTypes.shape({}),
    currentLanguage: PropTypes.string,
    callCloseCarousel: PropTypes.func
  }

  constructor(props) {
    super(props);
    debug('Within Filter Component');
  }

  state = {
    startDate: '',
    changeFilterColor: false
  }

  componentWillReceiveProps() {
    let changeFilterColor = false;
    const filtersList = util.inspectionFilterCRMFieldMap(null, this.props.strings);
    Object.keys(util.inspectionFilterCRMFieldMap(null, this.props.strings)).map((item) => {
      const filterLabel = filtersList[item].type;
      if (this.props.filterValues && this.props.filterValues[filterLabel] &&
        this.props.filterValues[filterLabel].length > 0) {
        changeFilterColor = true;
      }
      return changeFilterColor;
    });
    this.setState({ changeFilterColor });
  }

  setFilterChipValues = () => {
    const { strings } = this.props;
    if (this.props.activeIndex === undefined) {
      const filterChipTextAssignment = [
        { label: strings.none, value: -1 },
        { label: (this.props.filterValues.cica_writingagent[0] || strings.none), value: this.props.filterValues.cica_writingagent.length, marginRight: 10, marginRightIpad: 10 }, //eslint-disable-line
        { label: (this.props.filterValues.division[0] || strings.none), value: this.props.filterValues.division.length, marginRight: 22, marginRightIpad: 16 }, //eslint-disable-line
        { label: (this.props.filterValues.product[0] || strings.none), value: this.props.filterValues.product.length, marginRight: 9, marginRightIpad: 9 }, //eslint-disable-line
        { label: (this.props.filterValues.cica_appdate[0] || strings.none), value: this.props.filterValues.cica_appdate.length, marginRight: 58, marginRightIpad: 25 } //eslint-disable-line
      ];
      return filterChipTextAssignment;
    }
    const filterChipTextManage = [
      { label: strings.none, value: -1 },
      { label: (this.props.filterValues.cica_writingagent[0] || strings.none), value: this.props.filterValues.cica_writingagent.length }, //eslint-disable-line
      { label: (this.props.filterValues.product[0] || strings.none), value: this.props.filterValues.product.length }, //eslint-disable-line
      { label: (this.props.filterValues.division[0] || strings.none), value: this.props.filterValues.division.length }, //eslint-disable-line
      { label: (this.props.filterValues.cica_appdate[0] || strings.none), value: this.props.filterValues.cica_appdate.length } //eslint-disable-line
    ];
    return filterChipTextManage;
  }

  filterClick = () => {
    debug('Filter button clicked...');
    this.props.updateInspectionFilterExpanded(!this.props.inspectionFilterExpanded);
  }

  dataForFilters = ({ options }) => {
    if (!this.props.list.length) {
      return [];
    }
    return this.fillOptions(options);
  }

  fillOptions = (column) => {
    let columnData = '';
    columnData = util.inspectionFilterCRMFieldMap(column, this.props.strings);
    const mainList = this.props.rawInspectionsData &&
      this.props.rawInspectionsData.filter(obj => obj);
    let origlist = '';
    origlist = _.orderBy(_.compact(_.uniq(_.map(mainList, columnData))));
    let filteredList = '';
    filteredList = _.orderBy(_.compact(_.uniq(_.map(this.props.list, columnData))));
    let filteredIndex = 0;
    let shouldDisableField = false;
    if (columnData === this.props.activeFilter && this.props.filterValues[columnData].length > 0) {
      return this.props.activeFilterReplica;
    }
    return origlist.map((item) => {
      // debug('fillOptions - before list map - item', item);
      if (item !== filteredList[filteredIndex]) {
        shouldDisableField = true;
      } else {
        shouldDisableField = false;
        filteredIndex += 1;
      }
      return {
        clearableValue: false,
        disable: shouldDisableField,
        value: item,
        label: item
      };
    });
  }
  handleClearSearch = () => {
    this.props.updateNameSearchParameter('', this.props.activeIndex);
    this.props.updateWritingAgentParameter('', this.props.activeIndex);
    this.props.applyFilter();
  }
  clearAll = () => {
    this.props.clearFilter();
    this.props.applyFilter();
    this.setState({
      startDate: ''
    });
    this.props.updateNameSearchParameter('', this.props.activeIndex);
    this.props.updateWritingAgentParameter('', this.props.activeIndex);
    this.props.resetActiveFilter();
    this.props.callCloseCarousel(true);
  }

  renderFilterViews = () => {
    const { strings } = this.props;
    const views = this.props.inspectionFilterData.map((record) => {
      debug('views of inspectionsData', record);
      if (record.type === 'cica_appdate') {
        return (
          <div className={styles.filterItem} key={record.label}>
            <span>{strings.dateofapp}</span>
            <div //eslint-disable-line
              onClick={this.handleClearSearch}
            >
              <DatePickerComponent
                selected={this.state.startDate}
                maxDate={moment()}
                dateFormat={'MM-DD-YYYY'}
                dateFormatCalendar={'MM-DD-YYYY'}
                onDateChange={value => this.setState({
                  startDate: value
                })}
                type={record.type}
                hintText={record.hintText}
                activeIndex={this.props.activeIndex}
                updateFilter={this.props.updateFilter}
                applyFilter={this.props.applyFilter}
                activeFilter={this.props.setActiveFilter}
                replica={this.props.replicateActiveFilter}
                currentLanguage={this.props.currentLanguage}
              />
            </div>
          </div>
        );
      }
      return (
        <div className={styles.filterItem} key={record.label}>
          <label htmlFor={record.label}> {record.label} </label>
          <div //eslint-disable-line
            onClick={this.handleClearSearch}
          >
            <VirtualizedSelect
              labelKey="label"
              options={this.dataForFilters(record)}
              valueKey="value"
              type={record.type}
              hintText={record.hintText}
              activeIndex={this.props.activeIndex}
              filterValues={this.props.filterValues[record.type]}
              allFilters={this.props.filterValues}
              updateFilter={this.props.updateFilter}
              applyFilter={this.props.applyFilter}
              activeFilter={this.props.setActiveFilter}
              replica={this.props.replicateActiveFilter}
              updateNameSearchParameter={this.props.updateNameSearchParameter}
              updateWritingAgentParameter={this.props.updateWritingAgentParameter}
              currentLanguage={this.props.currentLanguage}
              callCloseCarousel={this.props.callCloseCarousel}
            />
          </div>
        </div>
      );
    });

    debug('views', _.compact(views));
    return _.compact(views);
  }
  /* eslint-disable */
  renderFilterExpanded() {
    const { strings } = this.props;
    return (
      <div className={styles.flexWrapperExpanded}>
        <div className={styles.filterBody}>
          {this.renderFilterViews()}
        </div>
        <div className={styles.filterCloseContainer}>
          <div className={styles.closeIconWrapper}>
            <img
              src="static/filter_close_btn.png"
              className={styles.filterCloseIcon}
              alt="Filter"
              onClick={this.filterClick}
            />
          </div>
          <div className={styles.clearFilterContainer}>
            <Button raised theme={styles} onClick={this.clearAll}>{strings.clearFilter}</Button>
          </div>
        </div>
      </div>
    );
  }

  renderFilter = () => (
    <div className={styles.flexWrapper}>
      {!__MANAGE__ && <div className={styles.emptySpace} />}
      {this.setFilterChipValues().map((chip, index) => (
        <FilterChip
          label={chip.label}
          value={chip.value}
          id={chip.id}
            /* In assign starting from index + 1 as the first column is Select check box and there is no filter for it
            */
          flexValue={`${__MANAGE__ ? this.props.flexValues[index] : this.props.flexValues[index + 2]}`}
          key={index}
          paddingLeft={chip.paddingLeft}
          marginRight={chip.marginRight}
          marginRightIpad={chip.marginRightIpad}
          leadTypeData={chip.leadTypeData}
        />
      ))}
      <div className={styles.filterContainer}>
        <img
          src="static/filter_ico.png"
          className={this.state.changeFilterColor ? styles.activeFilterIcon : styles.filterIcon}
          alt="Filter"
          onClick={this.filterClick}
        />
      </div>
    </div>
  );

  render() {
    debug(`Filter button state...${this.props.inspectionFilterExpanded}`);
    return (
      <div
        className={this.props.inspectionFilterExpanded ? styles.flexContainerExpanded : (__MANAGE__) ? styles.manageFlexContainer : styles.flexContainer}
      >
        {this.props.inspectionFilterExpanded ? this.renderFilterExpanded() : this.renderFilter()}
      </div>
    );
  }
}

/*
Following Actions are being mapped to props
  1) setActiveFilter
  2) replicateActiveFilter
  3) resetActiveFilter
*/

const mapStateToProps = state => ({
  activeFilter: state.filter.activeFilter,
  activeFilterReplica: state.filter.activeFilterReplica,
  rawInspectionsData: state.assign.inspectionsData
});

export default connect(mapStateToProps, actions)(InspectionFilter);


// WEBPACK FOOTER //
// ./src/components/InspectionFilter/InspectionFilter.js